import React from 'react'

const TicketDetails = ({ ticketDetails }) => {
  return (
    <div className="bg-white radius-8 p-15px mt-20px w-350px">
      <h2 className="text-16 w-600">Ticket details</h2>
      <div className="flex justify-between align-start gap-40px">
        <p>
          {ticketDetails?.name} (per {ticketDetails?.unit})
        </p>
        <h3>${ticketDetails?.price}</h3>
      </div>
      <div className="flex justify-between align-center">
        <h3>Total</h3>
        <h3>${ticketDetails?.amount}</h3>
      </div>
    </div>
  )
}

export default TicketDetails
